import { render, staticRenderFns } from "./carft.vue?vue&type=template&id=66015252&scoped=true&"
import script from "./carft.vue?vue&type=script&lang=js&"
export * from "./carft.vue?vue&type=script&lang=js&"
import style0 from "./carft.vue?vue&type=style&index=0&id=66015252&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66015252",
  null
  
)

export default component.exports